module.exports = __webpack_public_path__ + "static/media/3DPPA29.06ca48af.jpg";